import React, { useState } from 'react';
import { AddFaq } from '../../pages';
import * as yup from 'yup';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import { SupportController } from '../../controllers';

const AddFaqContainer = ({ closeModal, data }) => {
    const [loading, setLoading] = useState(false);
    const validationSchema = () => {
        return (
            yup.object().shape({
                question: yup.string().required("Enter FAQ"),
                answer: yup.string().required("Enter answer"),
                faqCategory: yup.string().required("Select FAQ category"),
            })
        )
    }

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            question: values.question,
            answer: values.answer,
            faqCategory: values.faqCategory,
        }
        const { status, errorMessage } = await SupportController.createFaq(payload);

        if (status === constant.Success) {
            SupportController.getFaqs();
            MimaToastUtil.success({ message: constant.Success })
            setLoading(false);
            return closeModal();
        } else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }
    return (
        <AddFaq
            validationSchema={validationSchema}
            loading={loading}
            closeModal={closeModal}
            data={data}
            onSubmit={onSubmit}
        />
    )
}
export default AddFaqContainer;